import styled from 'styled-components'
import CommonButton from 'components/Button/CommonButton'
import { Font14 } from 'components/Typography'
import Icon from '@mdi/react'
import theme from 'theme_'
import CommonLinkButton from 'components/Button/CommonLinkButton'

export const JobEditNoteContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const JobEditNoteHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const JobEditNoteHeaderTitle = styled.div`
  ${Font14};
`

export const JobEditNoteBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 28px 0 12px;
`

export const JobEditNoteFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  min-height: 40px;
`

export const JobEditNoteSaveButton = styled(CommonButton)`
  height: 40px;
`

export const JobEditNoteIcon = styled(Icon)`
  height: 20px;
  width: 20px;
  color: ${theme.colors.horizonOrange};

  :hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const JobEditCloseButton = styled(CommonLinkButton)`
  display: flex;
`

export const JobEditTextarea = styled.textarea`
  ${Font14};
  background: ${theme.colors.white};
  padding: 8px 16px;
  width: 100%;
  min-height: 80px;
  border: none;
  box-shadow: inset 0 0 0 1px ${theme.colors.pelicanGrey};
  border-radius: 8px;
  outline: none;
  resize: vertical;
  :focus {
    box-shadow: inset 0 0 0 1px ${theme.colors.horizonOrange};
  }
  ::placeholder {
    color: ${theme.colors.darkeyGrey};
  }
`

export const JobEditNoteErrorWrapper = styled.div`
  ${Font14};
  display: flex;
  justify-content: center;
  width: 100%;
  color: ${theme.colors.error};
  margin: 8px 0;
`
